import {useShopInfos} from "~/store/shopInfosStore";

export const getRouteWithprefix = (route:string)=> {
    const shopInfoStore = useShopInfos();
    return ["", shopInfoStore.getShopdirectoryLocalized, shopInfoStore.shopname].join("/")+(route !== "" ? "/"+route : "");
}
export const getRouteToHome = ()=>getRouteWithprefix("");
